// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flat-button {
  border-radius: 0 !important;
  outline: none;
  border: none;
  width: 500px;
  height: 26px;
  font-size: 16px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/misc/FlatButton.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".flat-button {\n  border-radius: 0 !important;\n  outline: none;\n  border: none;\n  width: 500px;\n  height: 26px;\n  font-size: 16px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
